// Styles
import "../scss/main.scss";

// Import asset images
import "./images";

// Import javascript
// import debounce from './helpers/debounce';

import toastr from "toastr";
import lottie from "lottie-web";
import SmoothScroll from "./partials/smoothScroll";
import cssVars from "css-vars-ponyfill";
import siteMenu from "./partials/siteMenu";
import sliders from "./partials/sliders";
import stickies from "./partials/sticky";
import videos from "./partials/videos";
// import alerts from "./partials/alerts";
import combos from "./partials/combos";
import activateReCaptcha from "./partials/reCaptcha";
import speakers from './partials/events/speakers';
import eventImages from './partials/events/images';
import search from './partials/search/search';
import eventEditor from './partials/events/editor';

document.addEventListener("DOMContentLoaded", function () {
  // toastr.options = {
  //   closeButton: false,
  //   debug: false,
  //   newestOnTop: false,
  //   progressBar: true,
  //   positionClass: "toast-bottom-right",
  //   preventDuplicates: false,
  //   onclick: null,
  //   showDuration: "300",
  //   hideDuration: "2000",
  //   timeOut: "5000",
  //   extendedTimeOut: "2000",
  //   showEasing: "swing",
  //   hideEasing: "linear",
  //   showMethod: "fadeIn",
  //   hideMethod: "fadeOut",
  // };

  lottie.loadAnimation({
    container: document.getElementById("footer-animation-inner"),
    renderer: "svg",
    loop: true,
    autoplay: true,
    path: "/assets/anim/footer.json",
  });

  cssVars({});
  siteMenu();
  sliders();
  videos();
  stickies();
  // alerts(toastr);
  activateReCaptcha();
  combos();

  new SmoothScroll('a[href*="#"]', { header: "#header" });

  window.addEventListener("resize", function () {
    document.documentElement.style.setProperty(
      "--vh",
      window.innerHeight * 0.01 + "px"
    );
  });
});
